import { inject, Injectable } from '@angular/core';
import { ApiFileAttachment, ApiV1Service } from 'api';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  private readonly apiService = inject(ApiV1Service);

  public downloadFileAttachment(fileAttachment: ApiFileAttachment): void {
    this.download(fileAttachment.id, fileAttachment.filename);
  }

  public download(fileId: number, fileName: string): void {
    // userAgent parameter will be replaced by JAX-RS on the backend side
    this.apiService
      .downloadDocument(fileId, undefined, 'body', false, { transferCache: false })
      .subscribe({
        next: (content) => {
          const url = URL.createObjectURL(content);

          const link = document.createElement('a');
          link.href = url;
          link.download = fileName ?? 'download';
          link.click();

          setTimeout(() => URL.revokeObjectURL(url), 0);
        },
        error: (error) => {
          console.error('Failed to download document', error);
        },
      });
  }
}
